import {
  Component,
  forwardRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  Injector
} from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { ControlContainer, ControlValueAccessor, FormControl, NgForm, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { default as ngLang } from '@angular/common/locales/zh';
import { WidgetRenderBase } from '../widget-render-base';

@Component({
  selector: 'app-r-string',
  templateUrl: './r-string.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RStringComponent),
      multi: true
    }
  ]
})
export class RStringComponent extends RenderComponentBase {
  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {}
  static KEY = 'r-d-string';
}
